import { render, staticRenderFns } from "./QuestionExplanationVideo.vue?vue&type=template&id=069dbb68&"
import script from "./QuestionExplanationVideo.vue?vue&type=script&lang=js&"
export * from "./QuestionExplanationVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports